import { useEffect, useState } from "react";
import { useAuthenticationContext } from "../context/AuthenticationContext";
import Confetti from "./Confetti";
import OnboardingModal from "./modals/OnboardingModal";
import PremiumUpsellHandler from "./PremiumUpsellHandler";

export default function OnboardingHandler() {
  const { user } = useAuthenticationContext();
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [onboardingCompleted, setOnboardingCompleted] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    // If user is logged in and hasn't completed onboarding, show the onboarding modal
    if (user && !user.filled_questionnaire) {
      setShowOnboarding(true);
    } else {
      setShowOnboarding(false);
    }
  }, [user]);

  const handleOnboardingComplete = () => {
    setShowOnboarding(false);
    setOnboardingCompleted(true);
    // Trigger confetti effect
    setShowConfetti(true);
    
    // Stop confetti after 4 seconds
    setTimeout(() => {
      setShowConfetti(false);
    }, 4000);
  };

  const resetOnboardingCompleted = () => {
    setOnboardingCompleted(false);
  };

  return (
    <>
      {showOnboarding && (
        <OnboardingModal 
          open={showOnboarding} 
          onComplete={handleOnboardingComplete} 
        />
      )}
      
      {/* Trigger confetti when onboarding is completed */}
      <Confetti active={showConfetti} duration={4000} particleDensity={60} />
      
      <PremiumUpsellHandler 
        onboardingCompleted={onboardingCompleted}
        resetOnboardingCompleted={resetOnboardingCompleted}
      />
    </>
  );
}